import { createStore } from 'vuex'

import authentication from "./modules/authentication";
import collectivite from "./modules/collectivite";
import map from "./modules/map";
import notifications from "./modules/notifications";
import parc from "./modules/parc";
import parcs from "./modules/parcs";
import renouvellements from "./modules/renouvellements";

const store = createStore({
  modules: { authentication, collectivite, map, notifications, parc, parcs, renouvellements }
});

export default store;
